import React from 'react';
import type { FederationRuntimePlugin } from '@module-federation/enhanced/runtime';
import { RetryPlugin } from '@module-federation/retry-plugin';

export const fallbackPlugin = (): FederationRuntimePlugin => ({
  name: 'fallback-plugin',
  errorLoadRemote() {
    return { default: () => <> </> };
  },
});

export const retryPlugin = (): FederationRuntimePlugin =>
  RetryPlugin({
    script: {
      retryTimes: 2,
      retryDelay: 1000,
      // moduleName: ['headerMfe','footerMfe'] - specific mfes, default retries all failed mfes
      cb: (resolve, error) => {
        if (error?.cause instanceof AggregateError && Array.isArray(error.cause.errors)) {
          // SSR fetch failure (Node.js via undici)
          for (const err of error.cause.errors) {
            if (err?.url) {
              console.error(`❌ RootMFE:Failed to fetch script: ${err.url}`);
            } else {
              console.error(`❌ RootMFE:Fetch error: ${err?.message || '[no message]'}`);
            }
          }
        } else if (error?.target?.src) {
          // Browser only
          console.error(`❌ RootMFE:Script load failed: ${error.target.src}`);
        } else if (error?.message?.includes('fetch') && error?.cause?.errors?.length) {
          const fetchError = error.cause.errors[0];
          const attemptedUrl = fetchError?.url || '[unknown URL]';
          console.error(`❌ RootMFE:Fetch failed for script: ${attemptedUrl}`);
        } else if (error?.cause?.message) {
          console.error(`❌ RootMFE:General load error: ${error.cause.message}`);
        } else {
          console.error('❌ RootMFE:Unknown script load error:', error);
        }
        setTimeout(() => {
          resolve(error); // all retries failed then callback gets invoked
        }, 1000);
      },
    },
  });
